
const state = {
  permanentDomain: '',
  customer: {},
  rechargeGwpCode: null,
  employeeDiscountCode: null,
  employeeEmailDomains: [],
};

const mutations = {
  SET_CUSTOMER (state, customer) {
    state.customer = customer;
  },
  SET_PERMANENT_DOMAIN (state, domain) {
    state.permanentDomain = domain;
  },
  SET_RECHARGE_GWP_CODE (state, code) {
    state.rechargeGwpCode = code;
  },
  SET_EMPLOYEE_DISCOUNT (state, { discountCode, emailDomains }) {
    state.employeeDiscountCode = discountCode;
    state.employeeEmailDomains = emailDomains;
  },
};

const actions = {
  initCustomer ({ commit }, customer) {
    commit('SET_CUSTOMER', customer);
  },
  initPermanentDomain ({ commit }, domain) {
    commit('SET_PERMANENT_DOMAIN', domain);
  },
  initRechargeGwpCode ({ commit }, code) {
    commit('SET_RECHARGE_GWP_CODE', code);
  },
  initEmployeeDiscount ({ commit }, { discountCode, emailDomains }) {
    commit('SET_EMPLOYEE_DISCOUNT', { discountCode, emailDomains });
  },
};

export default {
  state,
  mutations,
  actions,
  namespaced: true,
};
